<template>
  <div class="grid-x flex-grow p-8 settings-db-mobile">
    <div class="flex flex-col space-y-4">
      <button class="btn btn-primary" @click="exportCustomers">
        Экспорт заказчиков в Excel
      </button>
      <button class="btn btn-primary" @click="exportContractors">
        Экспорт исполнителей в Excel
      </button>
    </div>
  </div>
</template>

<script>
import gate from '@/api/axios';

export default {
  methods: {
    exportCustomers: async () => {
      const response = await gate.get('/customers/export', {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'customers.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    exportContractors: async () => {
      const response = await gate.get('/contractors/export', {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'contractors.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
  },
};
</script>
